import React from 'react';
import {BrowserRouter, Routes, Route, Navigate} from 'react-router-dom';
import Layout from './components/layout.js';
import Home from './pages/home.js';
import Services from './pages/services.js';
import ServiceDetails from './pages/service-details.js';
import TrainingServices from './pages/training.js';
import ManagementTeam from './pages/management.js';
import Contact from './pages/contact.js';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout><Home/></Layout>}/>
        <Route path="/services" element={<Layout><Services/></Layout>}/>
        <Route path="/service-details" element={<Layout><ServiceDetails/></Layout>}/>
        {/* <Route path="/clients" element={<Layout><Home scrollTo="/clients?scrollTo=clients"/></Layout>}/> */}
        {/* <Route path="/about" element={<Navigate to="/#about" replace />}/> */}
        <Route path="/management" element={<Layout><ManagementTeam/></Layout>}/>
        <Route path="/training" element={<Layout><TrainingServices/></Layout>}/>
        <Route path="/contact" element={<Layout><Contact/></Layout>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
